import { defaultapiSetting } from "@/constants/apiSetting";
import axios from "axios";
const httpClient = axios.create(defaultapiSetting);

export default httpClient;



// WEBPACK FOOTER //
// ./src/common/service/HttpClient.js